import React, { useState } from "react";
import { FormFeedback } from "reactstrap";
import { Eye, EyeOff } from "react-feather";
import "./PasswordField.css";

const PasswordField = ({
  name,
  placeholder,
  value,
  errors,
  touched,
  onChange,
  onBlur,
}) => {
  const [visible, setVisible] = useState(false);
  const invalid = errors[name] && touched[name];

  return (
    <>
      <div className={`password-field${invalid ? " password-field--invalid" : ""}`}>
        <input
          type={visible ? "text" : "password"}
          name={name}
          id={name}
          placeholder={placeholder}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          className={`form-control password-field__input${
            invalid ? " is-invalid" : ""
          }`}
          autoComplete={
            name === "password" ? "current-password" : "new-password"
          }
        />
        <button
          type="button"
          className="password-field__toggle"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? "Hide password" : "Show password"}
          title={visible ? "Hide password" : "Show password"}
        >
          {visible ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
      {invalid && (
        <FormFeedback className="d-block">{errors[name]}</FormFeedback>
      )}
    </>
  );
};

export default PasswordField;
